import { z } from 'zod';

export const ALLOWED_STATEMENT_MIME = [
  'application/pdf',
  'text/csv',
  'image/jpeg',
  'image/png',
  'image/tiff',
] as const;

export const MAX_STATEMENT_BYTES = 50 * 1024 * 1024; // 50 MB

const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'expected YYYY-MM-DD');
const money = z.string().regex(/^-?\d+(\.\d{1,4})?$/).nullable().optional();

export const uploadStatementInputSchema = z.object({
  statementDate: isoDate,
  periodFrom: isoDate.nullable().optional(),
  periodTo: isoDate.nullable().optional(),
  fileName: z.string().trim().min(1).max(255),
  mimeType: z.string().trim().min(1).max(120),
  /** base64-encoded file contents (no data: prefix). */
  content: z.string().min(1),
  statementBeginningBalance: money,
  statementEndingBalance: money,
  reconciliationId: z.string().uuid().nullable().optional(),
});
export type UploadStatementInput = z.infer<typeof uploadStatementInputSchema>;

export const listStatementsQuerySchema = z.object({
  bankAccountId: z.string().uuid().optional(),
  reconciliationId: z.string().uuid().optional(),
});
export type ListStatementsQuery = z.infer<typeof listStatementsQuerySchema>;

/** Metadata for an uploaded statement (never includes the file bytes). */
export interface BankStatement {
  id: string;
  companyId: string;
  bankAccountId: string;
  statementDate: string;
  periodFrom: string | null;
  periodTo: string | null;
  fileName: string;
  fileSizeBytes: number;
  mimeType: string;
  fileHash: string;
  statementBeginningBalance: string | null;
  statementEndingBalance: string | null;
  reconciliationId: string | null;
  retainedUntil: string | null;
  legalHold: boolean;
  uploadStatus: string;
  createdAt: string;
}

export interface StatementViewUrl {
  url: string;
  expiresAt: string;
}
